
import { Component, Vue } from "vue-property-decorator";
import { PDropDownContainer } from "@/common/components";
import { PRow } from "@/common/components/look/PRow";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";
import SupportDropDownEntityId from "./SupportDropDownEntityId.vue";

@Component({
  name: "support-entity-id-filter",
  components: {
    PRow,
    PIcon,
    PDropDownContainer,
    SupportDropDownEntityId,
  },
})
export default class SupportEntityIdFilter extends Vue {}
